// extracted by mini-css-extract-plugin
export default {"tupacGrid":"do-z","tupacHeader":"eo-z","tupacHeader2":"fo-z","tupacMenu":"go-z","tupacMenu2":"ho-z","tupacMain":"io-z","tupacMain2":"jo-z"};